import * as sagas from '../helpers/sagas';
import { types } from '../actions/tara';
import { api } from '../resources/tara';

const takeLatest = [
  {
    type: types.TARA_GET_SURVEY,
    call: api.getSurvey,
  },
  {
    type: types.TARA_POST_SURVEY,
    call: api.postSurvey,
  },
];

const tara = takeLatest.map(sagas.makeTakeLatest);

export default tara;



// WEBPACK FOOTER //
// ./src/sagas/tara.js